/* eslint-disable prettier/prettier */
import { toast } from 'react-toastify'
import LeadsServices from '../../services/LeadsServices'
import { leadConstant } from '../constants/LeadConstants'

export const myLeadAction = (headers) => (dispatch) => {
  LeadsServices.myLead(headers)
    .then((data) => {
      dispatch({
        type: leadConstant.FETCHING_LEAD_SUCCESS,
        payload: data.data,
      })
    })
    .catch((err) => {
      dispatch({
        type: leadConstant.FETCHING_LEAD_FAILED,
        payload: err,
      })
    })
}
export const addLeadAction = (body, config, setLeads, setLoading) => (dispatch) => {
  LeadsServices.addLead(body, config)
    .then((data) => {
      dispatch({
        type: leadConstant.CREATE_LEAD_SUCCESS,
        payload: data.data,
      })
      if (data.status) {
        toast.success(data.message, {
          position: 'top-center',
          autoClose: 5000,
          pauseOnHover: false,
        })
        setLoading(false)
        setLeads({
          firstname: '',
          lastname: '',
          email: '',
          mobile: '',
          gender: '',
          country: '',
          state: '',
          city: '',
        })
      } else {
        setLoading(false)
        toast.error(data.message, {
          position: 'top-center',
          autoClose: 5000,
          pauseOnHover: false,
        })
      }
    })
    .catch((err) => {
      setLoading(false)
      dispatch({
        type: leadConstant.CREATE_LEAD_FAILED,
        payload: err,
      })
      if (err) {
        setLoading(false)
        toast.error('Failed to add lead', {
          position: 'top-center',
          autoClose: 5000,
          pauseOnHover: false,
        })
      }
    })
}
